var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-61 -615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_27757",
    "data-name": "Path 27757",
    transform: "translate(61 615)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 27.5 C 10.39402008056641 27.5 7.003870010375977 26.09576034545898 4.454060077667236 23.54594039916992 C 1.904240012168884 20.99612998962402 0.5 17.60597991943359 0.5 14 C 0.5 10.39402008056641 1.904240012168884 7.003870010375977 4.454060077667236 4.454060077667236 C 7.003870010375977 1.904240012168884 10.39402008056641 0.5 14 0.5 C 17.60597991943359 0.5 20.99612998962402 1.904240012168884 23.54594039916992 4.454060077667236 C 26.09576034545898 7.003870010375977 27.5 10.39402008056641 27.5 14 C 27.5 17.60597991943359 26.09576034545898 20.99612998962402 23.54594039916992 23.54594039916992 C 20.99612998962402 26.09576034545898 17.60597991943359 27.5 14 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14 1 C 10.5275707244873 1 7.262990951538086 2.352239608764648 4.807609558105469 4.807609558105469 C 2.352239608764648 7.262990951538086 1 10.5275707244873 1 14 C 1 17.47241973876953 2.352239608764648 20.73701095581055 4.807609558105469 23.19239044189453 C 7.262990951538086 25.64776039123535 10.5275707244873 27 14 27 C 17.47241973876953 27 20.73701095581055 25.64776039123535 23.19239044189453 23.19239044189453 C 25.64776039123535 20.73701095581055 27 17.47241973876953 27 14 C 27 10.5275707244873 25.64776039123535 7.262990951538086 23.19239044189453 4.807609558105469 C 20.73701095581055 2.352239608764648 17.47241973876953 1 14 1 M 14 0 C 21.73197937011719 0 28 6.268009185791016 28 14 C 28 21.73197937011719 21.73197937011719 28 14 28 C 6.268009185791016 28 0 21.73197937011719 0 14 C 0 6.268009185791016 6.268009185791016 0 14 0 Z",
    stroke: "none",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "call_black_24dp_1_",
    "data-name": "call_black_24dp (1)",
    transform: "translate(65 619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M5.753,4.556A9.576,9.576,0,0,0,6.1,6.57L5.17,7.5a11.531,11.531,0,0,1-.591-2.948H5.753M13.422,13.9a9.919,9.919,0,0,0,2.022.35v1.159a12,12,0,0,1-2.956-.583l.933-.926M6.5,3H3.778A.78.78,0,0,0,3,3.778,13.221,13.221,0,0,0,16.222,17,.78.78,0,0,0,17,16.222V13.508a.78.78,0,0,0-.778-.778,8.872,8.872,0,0,1-2.777-.443.653.653,0,0,0-.241-.039.8.8,0,0,0-.552.226l-1.711,1.711A11.782,11.782,0,0,1,5.816,9.059L7.527,7.348a.781.781,0,0,0,.194-.793,8.836,8.836,0,0,1-.443-2.777A.78.78,0,0,0,6.5,3Z",
    transform: "translate(0 0)",
    fill: "#19bc9c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call-1.a91abb47fdaeafc500fc2ca68d7adb7e.svg";
export { ForwardRef as ReactComponent };